(()=>{
 const fold=s=>s.toLocaleLowerCase('de').replaceAll('ß','ss').normalize('NFD').replace(/[\u0300-\u036f]/g,'');
 function init(root){
  if(root.dataset.initialized)return;root.dataset.initialized='true';
  const field=root.querySelector('[data-lex-query]'),entries=[...root.querySelectorAll('.lex-entry')];
  let letter='alle',category='alle';
  const alphabet=root.querySelector('.lex-alphabet');
  [...new Set(entries.map(x=>x.dataset.term[0]?.toLocaleUpperCase('de')).filter(Boolean))].sort((a,b)=>a.localeCompare(b,'de')).forEach(x=>{
   const b=document.createElement('button');b.type='button';b.dataset.lexLetter=x;b.textContent=x;b.setAttribute('aria-pressed','false');alphabet.append(b);
  });
  function render(){
   let count=0;const tokens=fold(field.value).trim().split(/\s+/).filter(Boolean);
   for(const e of entries){const match=(letter==='alle'||e.dataset.term[0]?.toLocaleUpperCase('de')===letter)&&(category==='alle'||e.dataset.category===category)&&tokens.every(t=>fold(e.dataset.term+' '+e.dataset.alias+' '+e.querySelector('.lex-definition').textContent).includes(t));e.hidden=!match;if(match)count++}
   root.querySelector('[data-lex-count]').textContent=count+' '+(count===1?root.dataset.singular:root.dataset.plural);
   root.querySelector('.lex-empty').hidden=count>0;
   root.querySelectorAll('[data-lex-letter]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.lexLetter===letter)));
   root.querySelectorAll('[data-lex-category]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.lexCategory===category)));
  }
  root.addEventListener('input',e=>{if(e.target===field)render()});
  root.querySelector('form').addEventListener('submit',e=>{e.preventDefault();render()});
  root.addEventListener('click',e=>{
   const l=e.target.closest('[data-lex-letter]'),c=e.target.closest('[data-lex-category]'),r=e.target.closest('[data-lex-reset]');
   if(l){letter=l.dataset.lexLetter;render()}if(c){category=c.dataset.lexCategory;render()}
   if(r){letter='alle';category='alle';field.value='';render();field.focus()}
  });
  render();
 }
 const scan=()=>document.querySelectorAll('[data-sw-lexicon]').forEach(init);
 scan();document.addEventListener('shopify:section:load',scan);
 document.addEventListener('shopify:block:select',e=>{const item=e.target.closest('.lex-entry');if(item){const root=item.closest('[data-sw-lexicon]');root.querySelector('[data-lex-reset]').click();item.open=true}});
})();
